import { type QueryClient } from '@tanstack/react-query';
import { type Cart } from '../../../../../../src/types/Cart';
import { REACT_QUERY_KEYS } from '../../../../../../src/types/react-query-keys';

export function getCartFromCache(client: QueryClient): Cart | null {
  const cart = client.getQueryData<Cart>([REACT_QUERY_KEYS.CART]);
  if (cart === undefined) {
    return null;
  }

  return cart;
}
